import { combineReducers } from "@reduxjs/toolkit";
import { reducer as formReducer } from "redux-form";
import {
  allUserReducer,
  loggedUsersReducer,
  partCartLoginUserReducer,
  userReducer,
} from "./reducers/userReducer";
import {
  allAssetReducer,
  assetReducer,
  assetDetailsReducer,
  getAssetsList,
} from "./reducers/assetReducer";
import { notificationReducer } from "./reducers/notificationReducer";
import {
  appUsageStatusReducer,
  customerReportReducer,
  locationUpdateReducer,
  loginStatusReducer,
  partiesVisitedTopDSE,
  partsAdditionalDataReducer,
  partsAnalysisReducer,
  topDSEKPIReducer,
  visitTrackerReducer,
  iwResearchReducer,
  noStockReducer,
  partskartLoginStatusReducer,
} from "./reducers/dashboardReducer";
import {
  orderCollectionReducer,
  partskartOrderCollectionReducer,
} from "./reducers/orderReducer";

const reducers = combineReducers({
  form: formReducer,
  loggedUser: userReducer,
  allUser: allUserReducer,
  loggedUsers: loggedUsersReducer,

  // dashboard KPI
  topDSEDetail: topDSEKPIReducer,
  loginKPIDetail: loginStatusReducer,
  partskartAppLoginDetail: partskartLoginStatusReducer,
  appUsageDetail: appUsageStatusReducer,
  partsAnalysisDetail: partsAnalysisReducer,
  partsAdditionalData: partsAdditionalDataReducer,
  customerReportDetail: customerReportReducer,
  partiesVisitedTopDseDetail: partiesVisitedTopDSE,

  newAsset: assetReducer,
  assetInfo: assetReducer,
  allAssets: allAssetReducer,
  assetDetail: assetDetailsReducer,
  userDetail: userReducer,
  assetList: getAssetsList,
  Notification_Detail: notificationReducer,
  parts_cart_users: partCartLoginUserReducer,
  location_update: locationUpdateReducer,
  visitTracker: visitTrackerReducer,
  orderCollection: orderCollectionReducer,
  partskartOrderCollection: partskartOrderCollectionReducer,
  iw_research_update: iwResearchReducer,
  no_stock_update: noStockReducer,
});

export default reducers;
